var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KButton',{on:{"click":_vm.openModal}},[_vm._v("Open modal")]),_vm._v(" "),(_vm.showModal)?_c('KModal',{attrs:{"title":"Title","submitText":"Submit","cancelText":"Close"},on:{"submit":_vm.closeModal,"cancel":_vm.closeModal}},[_vm._v("\n    Description\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }